import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44ce3132"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-title"
}
const _hoisted_7 = { class: "modal-body p-4" }
const _hoisted_8 = {
  key: 0,
  class: "card-text"
}
const _hoisted_9 = {
  key: 1,
  class: "card-text"
}
const _hoisted_10 = {
  key: 2,
  class: "library-content"
}
const _hoisted_11 = { class: "card-subtitle text-muted" }
const _hoisted_12 = ["onMousedown"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "title" }
const _hoisted_15 = {
  key: 3,
  class: "library-content"
}
const _hoisted_16 = { class: "card-subtitle text-muted" }
const _hoisted_17 = ["onMousedown"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "modal-footer" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"white-space":"nowrap"} }, "Previous object connection  ", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.type == 'start')
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, "Add starting point"))
            : (_openBlock(), _createElementBlock("h5", _hoisted_6, "Add building block")),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.type == 'start')
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Select a first building block to start your flow with. This building block will define the flow's trigger. "))
            : (_openBlock(), _createElementBlock("p", _hoisted_9, "Select a building block to add to your flow.")),
          (_ctx.type === 'start')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.category), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.objectTypes, (objectType, idx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                    (objectType.category === 'start')
                      ? (_openBlock(), _createElementBlock("div", {
                          onMousedown: _withModifiers(($event: any) => (_ctx.$emit('object-selected', { objectType })), ["stop","prevent"]),
                          key: idx,
                          class: _normalizeClass(['object-type', objectType.category])
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.vm.getIconUrl(objectType.icon)
                          }, null, 8, _hoisted_13),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(objectType.title), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["overlay", [objectType.subCategory, objectType.subCategory ? 'custom' : '']])
                          }, null, 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(['category-circle', objectType.category])
                          }, null, 2)
                        ], 42, _hoisted_12))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredObjectTypes, (objects, category) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: category,
                    class: _normalizeClass(['object-category', category])
                  }, [
                    _createElementVNode("h6", _hoisted_16, _toDisplayString(category), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(objects, (objectType, idx) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                        (objectType.category !== 'start')
                          ? (_openBlock(), _createElementBlock("div", {
                              onMousedown: _withModifiers(($event: any) => (_ctx.$emit('object-selected', { objectType, connectionType: _ctx.connectionType })), ["stop","prevent"]),
                              key: idx,
                              class: _normalizeClass(['object-type', objectType.category])
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.vm.getIconUrl(objectType.icon)
                              }, null, 8, _hoisted_18),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(objectType.title), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["overlay", [objectType.subCategory, objectType.subCategory ? 'custom' : '']])
                              }, null, 2),
                              _createElementVNode("span", {
                                class: _normalizeClass(['category-circle', objectType.category])
                              }, null, 2)
                            ], 42, _hoisted_17))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 2))
                }), 128))
              ]))
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_ctx.connectionTypes.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.connectionType) = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectionTypes, (connectionType) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: connectionType.key,
                      value: connectionType
                    }, _toDisplayString(connectionType.label), 9, _hoisted_23))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.connectionType]
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_24,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light",
            "data-dismiss": "modal",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          }, " Cancel ")
        ])
      ])
    ])
  ]))
}